import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { BiLogoFacebook, BiLogoLinkedin, BiLogoPinterestAlt, BiLogoTwitter } from "react-icons/bi";

const socials = [BiLogoTwitter, BiLogoLinkedin, BiLogoFacebook, BiLogoPinterestAlt];

const Footer = memo(() => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-white">
      <div className="section-shell py-16">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_0.8fr_0.8fr_0.8fr]">
          <div>
            <NavLink to="/" className="flex items-center gap-3" aria-label="GoTrip home">
              <img src="/media/logo/logo.png.webp" alt="GoTrip logo" className="h-10 w-auto" />
              <span className="text-xl font-black tracking-tight">GoTrip</span>
            </NavLink>
            <p className="mt-5 max-w-sm leading-7 text-slate-300">A modern booking platform for hotel stays, restaurant reservations, favorites, cart flows, and user dashboards.</p>
            <p className="mt-4 text-sm leading-7 text-slate-400">Built by Rashin Web Dev · Full-Stack Product & MVP Development.</p>
            <a href="https://www.rashin-web-dev.ir" className="mt-3 inline-flex text-sm font-bold text-white underline decoration-white/40 underline-offset-4 hover:text-gotrip-200">www.rashin-web-dev.ir</a>
            <div className="mt-6 flex gap-3">
              {socials.map((Icon, index) => (
                <a key={index} href="#!" className="grid h-10 w-10 place-items-center rounded-full bg-white/10 text-slate-200 transition hover:bg-white hover:text-slate-950">
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-black uppercase tracking-[0.2em] text-slate-400">Platform</h4>
            <nav className="mt-5 space-y-3 text-slate-300">
              <NavLink to="/rooms" className="block hover:text-white">Rooms</NavLink>
              <NavLink to="/foods" className="block hover:text-white">Restaurants</NavLink>
              <NavLink to="/cart" className="block hover:text-white">Cart</NavLink>
              <NavLink to="/dashboard" className="block hover:text-white">Dashboard</NavLink>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-black uppercase tracking-[0.2em] text-slate-400">Company</h4>
            <nav className="mt-5 space-y-3 text-slate-300">
              <NavLink to="/" className="block hover:text-white">About</NavLink>
              <NavLink to="/blog" className="block hover:text-white">Blog</NavLink>
              <NavLink to="/contact" className="block hover:text-white">Contact</NavLink>
              <a href="https://www.rashin-web-dev.ir" className="block hover:text-white">Portfolio</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-black uppercase tracking-[0.2em] text-slate-400">Support</h4>
            <nav className="mt-5 space-y-3 text-slate-300">
              <a href="#!" className="block hover:text-white">Help center</a>
              <a href="#!" className="block hover:text-white">Terms & conditions</a>
              <a href="#!" className="block hover:text-white">Privacy policy</a>
              <a href="#!" className="block hover:text-white">Payment support</a>
            </nav>
          </div>
        </div>

        <div className="mt-12 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 text-sm text-slate-400 sm:flex-row">
          <p>Copyright © {year} GoTrip. All rights reserved.</p>
          <p>Built by Rashin Web Dev · Building products from idea to deployment.</p>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
